export enum KnownSidebarModules {
  Dashboard = 'Dashboard',
  NieuweUitgifte = 'Nieuwe uitgifte',
  NieuweInname = 'Nieuwe inname',
  Transacties = 'Transacties',
  Openingstijden = 'Openingstijden',
}
